import { render } from "./ConsultaDocumentos.vue?vue&type=template&id=0721b792"
import script from "./ConsultaDocumentos.vue?vue&type=script&lang=js"
export * from "./ConsultaDocumentos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__